/* eslint-disable */

import React, { useEffect, useMemo, useReducer, useState } from "react";
import Select from "react-select";
import { Form } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import {
  editRegulationsRequestsType,
  editRegulationsRequestsStatus,
} from "dictionary/domains/EditRegulationsRequests";
import { useLookups } from "context/lookupsContext";
import { useEsriUrls } from "context/esriUrlsContext";
import { useAuth } from "context/auth";
import { handleLoading, useLoading } from "context/LoadingContext";
import useGetAllZones from "customHooks/useGetAllZones";
import performActionOnFeature from "utils/performActionOnFeature";
import handleGetDataFromInput from "utils/handleGetDataFromInput";
import Dialog from "components/Dialog/Dialog";
import addNewLog from "utils/addNewLog";
import { dialogReducer, dialogInitState } from "reducers/dialog";
import ParcelLaws from "../Tools/ParcelsSearch/components/ParcelLaws";
import FilesModal from "../Tools/ParcelsSearch/components/FilesModal";
import { generateTextFromJson } from "utils/generateTextFromJson";
import { NotificationManager } from "react-notifications";
import { ErrorHandelFunctionApp } from "utils/ErrorHandelFunction";

function ChangeZone() {
  const [lookups] = useLookups();
  const [esriUrls] = useEsriUrls();
  const { zonesLookup } = lookups;
  const { zones } = useGetAllZones();
  const [, loadingDispatch] = useLoading();

  const navigate = useNavigate();
  const [selectedModalZone, setSelectedModalZone] = useState(null);
  const [auth] = useAuth();
  const selectedModalZoneValue = useMemo(() => {
    const zoneOfZero = zones ? zones[0] : null;
    return (
      zones?.find((item) => item.ZONE_ID === selectedModalZone) ||
      zoneOfZero ||
      {}
    );
  }, [selectedModalZone, zones]);
  useEffect(() => {
    if (zonesLookup) setSelectedModalZone(zonesLookup[0]);
  }, [zonesLookup]);
  const methods = useForm();
  const {
    register,
    formState: { errors },
  } = methods;
  const { handleSubmit, control } = methods;

  const [filesDialogState, filesDispatchDialog] = useReducer(
    dialogReducer,
    dialogInitState
  );
  const toggleFilesDialog = () => {
    filesDispatchDialog({ type: "TOGGLE" });
  };
  const [files, setFiles] = useState([]);

  // ----
  async function onSubmit(data) {
    try {
      handleLoading(loadingDispatch, true);

      // create new request
      // get attachments that coming form the input
      const attachmentWithFileObj = files
        .filter((attachment) => attachment.inputFile)
        .map((attachment) => attachment.inputFile);
      const filesFromInput = handleGetDataFromInput(attachmentWithFileObj);
      const urlEditRegulationsRequests = `${process.env.REACT_APP_SERVICE_ENDPOINT}/${process.env.REACT_APP_UserTables_Table}/FeatureServer/${esriUrls.EditRegulationsRequests}`;
      const editRegulationsRequestsAddRes = await performActionOnFeature({
        url: urlEditRegulationsRequests,
        objs: [
          {
            ...data,
            USERNAME: auth.userDetails.details.userName,
            type: editRegulationsRequestsType["تعديل احكام استعمال"],
            status: editRegulationsRequestsStatus["تحت المعالجة"],
          },
        ],
        action: "add",
        files: filesFromInput,
      });
      const createdRequestObjectId =
        editRegulationsRequestsAddRes.addFeatureResults[0].objectId;
      // create zone request details
      const urlZoningRequests = `${process.env.REACT_APP_SERVICE_ENDPOINT}/${process.env.REACT_APP_UserTables_Table}/FeatureServer/${esriUrls.ZoningRequests}`;
      /* const resZoningRequests = */ await performActionOnFeature({
        url: urlZoningRequests,
        objs: [
          {
            ...data,
            REQUESTID: createdRequestObjectId,
          },
        ],
        action: "add",
        notificationMessages: { onSuccessMessage: "تم انشاء الطلب بنجاح" },
      });
      await addNewLog({
        ipAddress: auth.ipAddress,
        hostname: auth.hostname,
        logDescription: `${generateTextFromJson(data,"أرسال طلب التعديل")}`});
  
      navigate("/requests");
    } catch (error) {
      ErrorHandelFunctionApp(error)
    }
    handleLoading(loadingDispatch, false);
  }
  // handleFiles

  return (
    <>
      <div>
        <h2 className="content__title title mt-3">تغيير صفة الاستعمال</h2>

        <form onSubmit={handleSubmit(onSubmit)}>
          <Form.Group className="mb-3 input input-md" controlId="DESCRIPTION">
            <Form.Label className="required">وصف و سبب التعديل</Form.Label>
            <Form.Control
              autoComplete="off"
              as="textarea"
              type="text"
              {...register("DESCRIPTION", {
                required: "الرجاء ادخال الحقل",
              })}
            />
            {errors.DESCRIPTION && (
              <Form.Text className="text-danger">
                {errors.DESCRIPTION.message}
              </Form.Text>
            )}
          </Form.Group>
          <div>
            <button
              className="btn btn-primary"
              type="button"
              onClick={toggleFilesDialog}
            >
              مرفقات الطلب ({files.length})
            </button>
          </div>
          <Form.Label>الصفة</Form.Label>
          <Controller
            control={control}
            defaultValue=""
            name="ZONE_ID"
            render={({ field: { onChange, name, ref, value } }) => (
              <Select
                inputRef={ref}
                name={name}
                value={zonesLookup?.find((item) => item.value === value) || ""}
                classNamePrefix="react-select"
                options={zonesLookup}
                getOptionLabel={(option) => option.name}
                getOptionValue={(option) => option.code}
                onChange={(val) => {
                  onChange(val.value);
                  setSelectedModalZone(val.value);
                }}
              />
            )}
          />
          <div
            className="divider my-3"
            style={{ backgroundColor: "var(--primary)", height: "5px" }}
          />
          <ParcelLaws
            law={selectedModalZoneValue}
            methods={methods}
            showName={false}
          />
          <div className="sticky-button">
            <button type="submit" className=" btn btn--primary w-100">
              إرسال طلب التعديل
            </button>
          </div>
        </form>
      </div>
      <Dialog
        state={filesDialogState}
        dispatch={filesDispatchDialog}
        footer={false}
        title="مرفقات الطلب"
        closeButton
        centered
      >
        <FilesModal files={files} setFiles={setFiles} deletable />
      </Dialog>
    </>
  );
}

export default ChangeZone;
